import SearchGradientIcon from 'ui-components/SearchGradientIcon';
import { useTheme } from '@emotion/react'
import { Add, DeleteOutlineRounded, Description, Edit, EditOutlined, Search } from '@mui/icons-material'
import { Box, Button, capitalize, Grid, Tooltip, Typography, useMediaQuery } from '@mui/material'
// import { FetchAllStartupFeedbacks } from 'api/profile'
import { FetchAllRounds } from 'api/round'
import Cookies from 'js-cookie'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SET_USER_ACCESS } from 'store/actions'
import { useNavigate } from 'react-router-dom'
import AsyncTableListing from 'ui-components/AsyncTableListing'
import DealFlowListSkeleton from 'views/startup_applications/DealFlowListSkeleton'
import Shimmer from 'ui-components/Shimmer'
import { sanitizePersonName, handleDateValues, hasPermission } from 'utils/index'
import DeleteConfirmationDialog from 'ui-components/popups/DeleteConfirmationPopup'
// import placeHolderImage from "assets/no_data_images/no_data_rounds.svg"
import CustomInputField from 'ui-components/CustomInputField'
import { AddUserCollaborator, DeleteUserDataByID, FetchAllUsersData } from 'api/settings'
import toast from 'react-hot-toast'
import toast_message from "utils/toast_message.json"
import { FetchPermissionsTemplate } from 'api/permission'
import { useToast } from 'context/ToastContext'
import { Primary, Secondary } from 'ui-components/Buttons';
import CustomDialog from 'ui-components/CustomDialog'


const Users = ({ refetchListing, searchStatus, setSearchStatus, reset, search, setSearch, setReset, queryParams, setQueryParams, }) => {
  const theme = useTheme();
  const { addToast } = useToast();
  let [investor_id, setStartupID] = React.useState(Cookies.get("X-INV-ID") || null);
  const userPermissions = useSelector((state) => state?.permissions?.userPermissions);
  const isOwnerFlag = useSelector((state) => state?.permissions?.isOwner);
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate()
  const columns = [
    { Header: 'Name', accessor: 'name', minWidth: 150, align: 'start', fixed: true, hideEmail: true },
    { Header: 'Email', accessor: 'email', minWidth: 150, align: 'center' },
    { Header: 'Role', accessor: 'user_role_type', minWidth: 150, align: 'center' },
    { Header: 'Created Date', accessor: 'formatted_date', minWidth: 150, align: 'center' },
    { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'end' },
  ];


  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(10);
  const [sort, setSort] = React.useState(-1);
  // const [search, setSearch] = React.useState(-1);
  const { data: userData, isLoading: isLoadingUserData, refetch: refetchUsersData } = FetchAllUsersData({ investor_id, limit, page, searchText: search, enabled: hasPermission("settings", "manage_users", userPermissions) })
  const {
    data: permissions_template,
    isLoading: isLoadingPermissionsTemplate,
    refetch: refetchPermissionsTemplate
  } = FetchPermissionsTemplate();
  const {
    mutateAsync: deleteUserDataAsync,
    isLoading: isDeletingUserData,
    status: deleteUserDataStatus,
    error: deleteUserDataError,
    data: deleteUserDataResponse
  } = DeleteUserDataByID();

  const formattedUsersData = React.useMemo(() => {
    const dataArray = userData?.data || [];
    return !isLoadingUserData ? dataArray?.map(user => {
      return ({
        ...user,
        name: user?.user_details?.first_name + " " + user?.user_details?.last_name,
        email: user.user_details?.email,
        user_role_type: user?.user_role_type ? capitalize(user?.user_role_type) : '-'
      })
    }) : []
  }, [userData, isLoadingUserData])

  // ── Owner name edit ──────────────────────────────────────────────────────
  // Uses PUT investors/edit-collaborator (the same endpoint the collaborator edit
  // uses), NOT POST /investors. That matters: /investors writes the name onto
  // investorModel.personal_information, and angel accounts derive investor_name
  // from that field - so renaming there renamed every account in the Switch
  // Account list at once. edit-collaborator touches only the user record, which
  // is exactly what this listing displays (getCollaboratorListing reads
  // userModel.user_details via collaborator.user_id).
  //
  // Permissions are safe: editCollaborator only assigns permission /
  // user_role_type when they are present in the body, and we send neither.
  //
  // ⚠️ Needs a backend change to take effect. In investors.service.ts the name
  // block (`updateData['user_details.first_name'] = ...`) is commented out AND
  // sits after an unconditional `return`, so today this call succeeds without
  // changing the name. Move that block above the return and uncomment it.
  const { mutateAsync: editCollaboratorAsync, isLoading: isSavingName } = AddUserCollaborator();
  const [showEditNamePopup, setShowEditNamePopup] = React.useState(false);
  const [nameDraft, setNameDraft] = React.useState({ first_name: '', last_name: '' });
  const [editingUser, setEditingUser] = React.useState(null);

  const handleOpenEditName = (row) => {
    setEditingUser(row);
    setNameDraft({
      first_name: row?.user_details?.first_name || '',
      last_name: row?.user_details?.last_name || '',
      email: row?.email
    });
    setShowEditNamePopup(true);
  };

  const handleSaveName = async () => {
    const first_name = nameDraft.first_name?.trim();
    const last_name = nameDraft.last_name?.trim();
    const email = nameDraft.email?.trim();
    if (!first_name) {
      addToast('First name is required', 'error');
      return;
    }
    try {
      await editCollaboratorAsync({
        isEditMode: true,
        payload: {
          _id: editingUser?._id,        // the collaborator record
          user_id: editingUser?.user_id, // the user whose user_details hold the name
          first_name,
          last_name,
email
      
        },
      });
      setShowEditNamePopup(false);
      refetchUsersData();

      // The sidebar footer reads userName out of Redux, which is only populated by the
      // permissions API at app load - so without this it keeps the old name until a
      // refresh. Only the owner renaming THEMSELVES should move it; renaming a
      // collaborator must not.
      // permissions and isOwner are passed through unchanged because the reducer
      // replaces all three fields on this action - omitting them would blank the
      // user's permissions app-wide.
      if (editingUser?.is_owner) {
        dispatch({
          type: SET_USER_ACCESS,
          permissions: userPermissions,
          isOwner: isOwnerFlag,
          userName: [first_name, last_name].filter(Boolean).join(' '),
        });
      }

      addToast('Name updated', 'success');
    } catch (err) {
      addToast(err?.response?.data?.message || 'Could not update the name', 'error');
    }
  };

  const [currentRow, setCurrentRow] = React.useState(null);
  const [showDeletePopup, setShowDeletePopup] = React.useState(false);

  const handleOpenDeletePopup = () => {
    setShowDeletePopup(true);
  }

  const handleCloseDeletePopup = () => {
    setShowDeletePopup(false);
  }

  const handleDeleteUser = () => {
    // console.log(currentRow?._id,"ddd")
    deleteUserDataAsync({ user_id: currentRow?._id }, {
      onSuccess: () => {
        refetchUsersData();
        handleCloseDeletePopup();
        // toast.success(toast_message?.users?.delete)
        addToast(toast_message?.users?.delete, "success")
      },
      onError: () => {
      }
    })
  }
  React.useEffect(() => {
    refetchUsersData();
  }, [reset]);

  const RowActions = ({ row }) => {
    const currentLocation = window.location;
    // console.log(row?.original,"row")

    // The owner has no permissions to edit (they hold them all) and cannot be
    // deleted, so their only action is renaming themselves.
    if (row?.original?.is_owner) {
      return (
        <div style={{ display: "flex", marginLeft: 'auto' }}>
          <Tooltip title="Edit Name">
            <Button sx={{ minWidth: "1rem" }} onClick={() => handleOpenEditName(row?.original)}>
              <EditOutlined sx={{ color: theme.palette.customColors.indigo700 }} />
            </Button>
          </Tooltip>
        </div>
      );
    }

    return (!row?.original?.is_owner ? <div style={{ display: "flex", marginLeft: 'auto' }}>
      <Tooltip title="Edit Permissions">
        <Button sx={{ minWidth: "1rem" }} onClick={() => {
          Cookies.set("settings_user_id", row?.original?._id)
          refetchPermissionsTemplate();
          if (currentLocation.pathname?.includes("/settings")) {
            navigate("add_user")
          }
          else {
            navigate("/settings/add_user")
          }
        }}>
          <EditOutlined
            sx={{ color: theme.palette.customColors.indigo700 }}

          />
        </Button>
      </Tooltip>
      <Tooltip title="Delete">
        <Button
          sx={{ minWidth: "1rem" }}
          onClick={() => { setCurrentRow(row?.original); handleOpenDeletePopup() }}
        >
          <DeleteOutlineRounded
            sx={{ color: theme.palette.customColors.indigo700 }} />
        </Button>
      </Tooltip>
    </div> : "")
  }

  return (
    <>
      <DeleteConfirmationDialog open={showDeletePopup} handleClose={handleCloseDeletePopup} handleSubmission={handleDeleteUser} heading={"Delete User"} ActionText={"Confirm"} subheading={"Are you sure you want to delete this user?"} />

      <CustomDialog
        open={showEditNamePopup}
        handleClose={() => setShowEditNamePopup(false)}
        title="Edit Name"
        maxWidth="xs"
        actions={
          <Box sx={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
            <Secondary
              sx={{ padding: '9px 24px', borderRadius: '8px', minWidth: '100px', fontSize: '0.9rem' }}
              onClick={() => setShowEditNamePopup(false)}
              disabled={isSavingName}
            >
              Cancel
            </Secondary>
            <Primary
              sx={{ padding: '9px 24px', borderRadius: '8px', minWidth: '100px', fontSize: '0.9rem' }}
              onClick={handleSaveName}
              disabled={isSavingName}
            >
              {isSavingName ? 'Saving...' : 'Save'}
            </Primary>
          </Box>
        }
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <CustomInputField
            label="First Name"
            placeholder="Enter first name"
            value={nameDraft.first_name}
            onChange={(e) => setNameDraft((prev) => ({ ...prev, first_name: sanitizePersonName(e.target.value) }))}
          />
          <CustomInputField
            label="Last Name"
            placeholder="Enter last name"
            value={nameDraft.last_name}
            onChange={(e) => setNameDraft((prev) => ({ ...prev, last_name: sanitizePersonName(e.target.value) }))}
          />
        </Box>
      </CustomDialog>
      <Grid container xs={12} pt={1.1} pb={0} spacing={2} display={"flex"} justifyContent={"space-between"} marginLeft={0} alignContent={"flex-start"} >
        {isLoadingUserData ?

          <Box width={"100%"} paddingLeft={"2rem"} maxWidth={"100%"} overflow={'hidden'} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }}>
            {/* Mirrors the search + Add User bar above the loaded table. */}
            <Grid container padding={"0.5rem"} sx={{
              border: `1px solid ${theme.palette.customColors.b50}`,
              borderRadius: '8px 8px 0px 0px',
              background: theme?.palette.customColors.whiteBG,
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              flexWrap: 'nowrap',
            }}>
              <Grid item sx={{ display: 'flex', flex: 1, minWidth: 0 }}>
                <Shimmer width="100%" height={44} radius={8} />
              </Grid>
              <Grid item sx={{ display: 'flex', flexShrink: 0 }}>
                <Shimmer width={isSmallScreen ? 64 : 124} height={44} radius={8} />
              </Grid>
            </Grid>
            <DealFlowListSkeleton
              columns={columns}
              rows={limit}
              sx={{ borderRadius: '0px 0px 8px 8px', border: `1px solid ${theme.palette.customColors.b50}`, bgcolor: "white" }}
            />
          </Box>
          :
          <Box width={"100%"} paddingLeft={"2rem"} maxWidth={"100%"} overflow={'hidden'} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }}>
            <Grid container padding={"0.5rem"} sx={{
              border: `1px solid ${theme.palette.customColors.b50} !important`,
              borderRadius: '8px 8px 0px 0px',
              background: theme?.palette.customColors.whiteBG,
              // Search + Add share one row (search grows, Add stays its own size) at
              // every breakpoint, instead of Add wrapping to a second line on mobile.
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              flexWrap: 'nowrap',
            }}>
              <Grid item style={{ display: 'flex', flex: 1, minWidth: 0, height: 'min-content', alignItems: 'center', gap: "0.5rem" }}>
                <CustomInputField
                  autoComplete="off"
                  sx={{
                    marginBottom: 0,
                    "& > .MuiFilledInput-root": {
                      borderColor: `${theme.palette.customColors.b50} !important`,
                      borderRadius: '8px'
                    }
                  }}
                  fullWidth
                  value={search}
                  name={`search_${Math.random().toString(36).substring(7)}`}  // Set a random name attribute
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      // alert(e.target.value);
                      refetchUsersData()
                      if (search) {
                        setSearchStatus(true)
                      }
                      setPage(1);
                    }
                  }}
                  onChange={(event) => {
                    setSearch(event.target.value);
                    Cookies.set("search_startup_settings", event.target.value);
                    setSearchStatus(false)
                  }}
                  size="small"
                  startAdornment={<>
                    <SearchGradientIcon />
                  </>}
                  placeholder={'Search by name'}
                />
                {/* Search button removed - the search field alone drives search (type + Enter,
                    clear + Enter shows all). Kept here for reference.
                <Primary onClick={() => {
                  if (searchStatus && (search !== '' || Object.keys(queryParams)?.length > 0)) {
                    setSearch('')
                    Cookies.set("search_startup_settings", "");
                    setReset(!reset)
                  } else {
                    refetchUsersData()
                  }
                  setSearchStatus((oldVal) => !oldVal)
                  setPage(1);
                }} sx={{ padding: ".7rem 1.25rem", bgcolor: searchStatus && (search !== '') ? "#e9f5f8" : theme.palette.customColors.b300, ":hover": { bgcolor: searchStatus && (search !== '') ? "#e9f5f8" : theme.palette.customColors.b400 }, border: `0px solid ${searchStatus && (search !== '') ? "black" : "inherit"}`, color: searchStatus && (search !== '') ? theme.palette.customColors.b300 : "white" }}  >{(searchStatus && (search !== '')) ? "Reset" : "Search"}</Primary>
                */}


              </Grid>
              <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'end', flexShrink: 0 }}>
                <Primary
                  onClick={() => {
                    Cookies.remove("settings_user_id");
                    navigate("/settings/add_user");
                  }}
                  sx={{
                    // bgcolor: theme.palette.customColors.indigo600,
                    // border: `1px solid ${theme.palette.customColors.indigo600} `,
                    padding: '10px 16px',
                    fontWeight: 600,
                    minWidth: isSmallScreen ? "0" : '64px',
                    '& > .MuiButton-icon.MuiButton-startIcon': {
                      marginRight: isSmallScreen ? 0 : '8px',
                      marginLeft: isSmallScreen ? 0 : '-4px'
                    }
                  }}
                  startIcon={<Add fontSize='1.25rem' />}
                >
                  {!isSmallScreen ? "Add User" : "Add"}
                </Primary>
              </Grid>
            </Grid>

            <Grid id="users-settings-table">
              <AsyncTableListing
                actions={() => !(search?.trim()?.length > 0 && searchStatus) ? <Primary
                  // onClick={() => { navigate("/add_user") }}
                  onClick={() => {
                    Cookies.remove("settings_user_id");
                    navigate("/settings/add_user");
                  }}
                  sx={{
                    // bgcolor: theme.palette.customColors.indigo600,
                    // border: `1px solid ${theme.palette.customColors.indigo600} `,
                    padding: '10px 16px',
                    fontWeight: 600,
                    minWidth: isSmallScreen ? "0" : '64px',
                    '& > .MuiButton-icon.MuiButton-startIcon': {
                      marginRight: isSmallScreen ? 0 : '8px',
                      marginLeft: isSmallScreen ? 0 : '-4px'
                    }
                  }}
                  startIcon={<Add fontSize='1.25rem' />}
                >
                  {!isSmallScreen ? "Add User" : "Add"}
                </Primary> : null}
                // isLoading={isLoadingFeedbacks}
                columns={columns}
                data={formattedUsersData}
                page={page}
                setPage={setPage}
                limit={limit}
                setLimit={setLimit}
                count={10}
                RowActions={RowActions}
                // tabValue={value}
                pagination={true}
                sx={{
                  borderRadius: '0px 0px 8px 8px',
                  border: `1px solid ${theme.palette.customColors.b50}`,
                  bgcolor: "white"
                }}
                noDataTitle='No Users Found'
                noDataSubTitle=''

              />
            </Grid>
          </Box>
        }

      </Grid>
    </>
  )
}

export default Users
